import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/anl-attentions.svg',
})
export class AnlAttentionsComponent {}
